import { IAction, actions } from "../type";
import { quizId, quizType } from "../utils/constants";

const initialState: any = {
  type: quizType,
  id: quizId,
  flags: [],
  attempts: {},
  answers: {},
  version: 1,
  started: false,
  resume: false,
  progressId: null,
  loading: false,
  fetchQuizLoading: false,
};

interface Attempts {
  [key: string]: string;
}

interface Answers {
  [key: string]: { ans: any; answerVal: string; duration: number };
}

const quiz = (state = initialState, action: IAction) => {
  switch (action.type) {
    case actions.SAVE_QUIZ_DATA: {
      const { quizData, progressData } = action.payload;
      let newAttemps: Attempts = {};
      let newAnswers: Answers = {};
      let newFlags: any = [];
      let newVersion: any = 1;
      let newStartTime = "";
      let hasStarted = false;
      let newProgressId = null;
      if (!progressData) {
        const questions = quizData.questions;
        questions.map((qst: any) => (newAttemps[qst._id] = qst.retries));
        questions.map(
          (qst: any) =>
            (newAnswers[qst._id] = { ans: null, answerVal: "", duration: 0 })
        );
      } else {
        const {
          _id,
          progress: {
            attempts: atms,
            answers: anws,
            flags: flgs,
            version,
            started: strt,
            startQuizTime,
          },
        } = progressData;
        newAttemps = atms;
        newVersion = version;
        newAnswers = anws;
        newFlags = flgs;
        newStartTime = startQuizTime;
        hasStarted = strt;
        newProgressId = _id;
      }

      return {
        ...state,
        data: quizData,
        type: quizType,
        id: Number(quizId),
        attempts: newAttemps,
        answers: newAnswers,
        flags: newFlags,
        version: newVersion,
        started: hasStarted,
        resume: false,
        progressId: newProgressId,
        fetchQuizLoading: false,
        startQuizTime: newStartTime,
      };
    }

    case actions.UPDATE_FLAG: {
      let flags = [...state.flags];
      if (flags.includes(action.payload)) {
        flags = flags.filter((f: string) => f !== action.payload);
      } else {
        flags.push(action.payload);
      }
      return {
        ...state,
        flags,
      };
    }
    case actions.UPDATE_ANSWER: {
      const { id, ans, answerVal, duration } = action.payload;
      const oldAnswers = { ...state.answers };
      const prevDuration = oldAnswers[id].duration;
      oldAnswers[id] = { ans, answerVal, duration: prevDuration + duration };
      return {
        ...state,
        answers: oldAnswers,
      };
    }
    case actions.UPDATE_ATTEMPTS: {
      const aid = action.payload;
      const oldAttempts = { ...state.attempts };
      oldAttempts[aid] = oldAttempts[aid] - 1;
      return {
        ...state,
        attempts: oldAttempts,
      };
    }
    case actions.UPDATE_START: {
      const started = action.payload;
      return {
        ...state,
        started,
        version: state.version + 1,
      };
    }
    case actions.UPDATE_RESUME: {
      const resume = action.payload;
      return {
        ...state,
        resume,
      };
    }
    case actions.TOGGLE_LOADING: {
      return {
        ...state,
        loading: action.payload,
      };
    }
    case actions.REQUEST_QUIZ_DATA: {
      return {
        ...state,
        fetchQuizLoading: true,
      };
    }
    default:
      return state;
  }
};

export default quiz;
